module.exports = __webpack_public_path__ + "img/car_shina2_34.43656a84.jpg";